var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"nav-link padding-raro",class:{active: _vm.active},attrs:{"type":"button"},on:{"click":_vm.onClick}},[(_vm.icon)?_c('img',{attrs:{"src":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }